import styled from 'styled-components';
import {
  black,
  border1,
  boxShadow1,
  exactWhite,
  gray,
  selected,
} from 'utils/style/colors';

interface IItemsProp {
  helve: boolean;
  width?: string;
}
export const ConfigItems = styled.ul<IItemsProp>`
  margin: 10px;
  border: ${border1};
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  background-color: ${gray};
  padding: 10px !important;
  flex: 1;
  max-width: ${(props) => {
    if (props.width) return props.width;
    return props.helve ? '50%' : '100%';
  }};
  overflow: scroll;
  height: 100%;
`;

interface IItemProp {
  isActive: boolean;
}

export const Item = styled.li<IItemProp>`
  border: ${border1};
  cursor: pointer;
  margin: 10px;
  display: flex;
  padding: 10px 20px;
  position: relative;
  transition: all 0.3s ease;
  box-sizing: border-box;
  align-items: center;
  border-radius: 10px;
  background-color: var(--exact-white);
  &:hover {
    background-color: #dcdcdc;
  }
  ${({ isActive }) =>
    isActive &&
    `
      border: 1px solid #34c8b6;
      background-color: #dcdcdc;
  `}
`;

export const ProjectItemContainer = styled.div`
  background: ${(props) => (props.isSelected ? selected : undefined)};
  color: ${(props) => (props.isSelected ? exactWhite : undefined)};
  border-radius: 1rem !important;
  overflow: hidden !important;

  & > * {
    background-color: ${(props) => props.isSelected && `${black} !important;`};
  }
`;
